import React, { useCallback, useEffect,  useRef,  useState } from 'react'
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { employee, employeesSlice, employeesState } from './EmployeesSlice'
import { addEmployeeSlice } from './AddModal/AddModalSlice'

// API
import  { sortDirectionType } from '../../services/api/api'

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar'

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader'
import { Confirm } from '../../components/Alerts/Alerts'
import AddModal from './AddModal/AddModal'
import SlariesModal from './Salaries/SlariesModal'
import { salariesSlice } from './Salaries/SalariesSlice'
import SalariesHistoryModal from './SalariesHistory/SalariesHistoryModal'
import { havePermission } from '../../services/hoc/permissions'
import { getListSort } from '../../services/hoc/sort'
import { SortTable } from '../../components/Table/SortTable'
import { RowContainer } from '../../components/Table/row_container'
import { AxiosError } from 'axios'
import { useNotification } from '../../services/usenotification'
import { useAPI } from '../../services/hoc/useAPI'

export default () => {

    // Translation
    const t = useTranslation()
    const [pagesInfo,setPagesInfo]=useState({page:1,lastPage:1})
    const {alertError500 } =useNotification()
    // Redux
    const dispatch = useDispatch()
    const state = useSelector( ( state: { employees: employeesState } ) => state.employees )
 const keyword_ref = useRef<string|null>(null)

    const [activeEmployee, setActiveEmployee] = useState<number>(-1)

const ENDPOINTS = useAPI()
    
    // Search
    const search = (value: string) => {
     
        dispatch( employeesSlice.actions.reset() )
           keyword_ref.current=Boolean(value)?value:null
        fetchData(1,8,Boolean(value)?value:'')
    }

    // Fetch Data
    const fetchData = useCallback((
                          page: number
                        , page_size: number = 8
                        , keyword?:string
                        , sort_direction?:sortDirectionType
                        , sort_field?:number) => {

        dispatch( employeesSlice.actions.setIsFetching( true ) )
keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
        ENDPOINTS.employees().index({ page, page_size, keyword
            ,sort_direction
            ,sort_field 
        })
        .then((response: any) => {
            let employees: employee[] = response.data.data.employees
            dispatch( employeesSlice.actions.setIsFetching( false ) )
            dispatch( employeesSlice.actions.init( employees ) )
            dispatch( employeesSlice.actions.setHasMore( page < Number(response.data.data.last_page) ) )
          
            if( !state.isLoaded )
                dispatch( employeesSlice.actions.setIsLoaded( true ) )
        })
        .catch((err:AxiosError)=>{
            alertError500(err)
            dispatch( employeesSlice.actions.setIsFetching( false ) )
        })
    },[dispatch,ENDPOINTS,state.isLoaded])

    const fetchSortedData =useCallback((sort_field:number,sort_direction:sortDirectionType)=>{
        if (sort_direction && sort_field){
         fetchData(state.page,8,'',sort_direction,sort_field)
         
        }
      },[state.page])
    

    
    // const generateData: () => tableDataType = () => {
        
    //     let data: tableDataType = {}
    //     state.employees[state.page]?
    //     state.employees[state.page].map((employee, index) => {
    //         data[employee.id] = {
    //             name: employee.name,
    //             serial_no: employee.serial_no,
    //             mobile: employee.mobile,
    //             job: employee.job,
    //             salary: employee.salary,
    //             workingStatus: employee.workingStatus,
    //             actions: <div className="show-on-hover">
    //                         <i className="icon-receipt" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
    //                             e.stopPropagation()
    //                             setActiveEmployee(index)
    //                         } } />
    //                         { havePermission("Edit Employee") ?
    //                         <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
    //                             e.stopPropagation()
    //                             dispatch( addEmployeeSlice.actions.setIsOpen(true) )
    //                             dispatch( addEmployeeSlice.actions.setEditId(employee.id) )
    //                             dispatch( addEmployeeSlice.actions.set(employee) )
    //                         } } /> : "" }
    //                         { havePermission("Delete Employee") ?
    //                         <i className="icon-delete" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
    //                             e.stopPropagation()
    //                             Confirm({
    //                                 message: t("delete_confirmation"),
    //                                 onConfirm: () => remove(employee.id)
    //                             })
    //                         }} /> : "" }
    //                     </div>
    //         }
    //     }):null

    //     return data
    // }
    const actions= (employee:employee,index:number)=>(
        <div className="show-on-hover">
        <i className="icon-receipt" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            e.stopPropagation()
            setActiveEmployee(index)
        } } />
        { havePermission("Edit Employee") ?
        <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            e.stopPropagation()
            dispatch( addEmployeeSlice.actions.setIsOpen(true) )
            dispatch( addEmployeeSlice.actions.setEditId(employee.id) )
            dispatch( addEmployeeSlice.actions.set(employee) )
        } } /> : "" }
        { havePermission("Delete Employee") ?
        <i className="icon-delete" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            e.stopPropagation()
            Confirm({
                message: t("delete_confirmation"),
                onConfirm: () => remove(employee.id)
            })
        }} /> : "" }
    </div>
    )
const rows=()=>{
    return (
        state.employees[state.page]?
        state.employees[state.page].map((employee, index) => {
         return  ( <RowContainer 
            item_id={employee.id.toString()}
            onSelect={toggleSelectedId}
            state_length={state.employees[state.page].length}
            tr_index={index}
            columns={[
                employee.name,
                employee.serial_no,
                employee.mobile,
                employee.job,
                employee.salary,
                employee.workingStatus,
                actions(employee,index)
            ]}
            />)
        }):null
    )
}

    // Toggle Selected id
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const toggleSelectedId = (id: number) => {
        if(!havePermission("Delete Employee"))
            return
        let index = selectedIds.findIndex(selectedId => selectedId === id)
        if( index !== -1 ) {
            setSelectedIds(selectedIds.filter(selectedId => selectedId !== id))
        } else
            setSelectedIds([...selectedIds, id])
    }

    // Delete
    const remove = (id?: number) => {
        
        let ids = id ? [id] : selectedIds.map(x => +x)
        dispatch( employeesSlice.actions.setIsLoading(true) )
        ENDPOINTS.employees().delete({ ids })
        .then(() => {
            setSelectedIds([])
            dispatch( employeesSlice.actions.setIsLoading(false) )
       
            dispatch( employeesSlice.actions.deleteEmployees(ids) )
        })

    }

    // First fetch
    useEffect(() => {
        if( !state.isFetching )
            fetchData(1)
    }, [])
    
    useEffect(()=>{
        if (pagesInfo &&  pagesInfo.page!== state.page){
            if(  !state.isFetching ) {
              employeesSlice.actions.setPage(pagesInfo.page)
              fetchData(pagesInfo.page)
            }
        }
      },[pagesInfo])
      
     
    return(
        <>
            { state.isLoaded ?
            <>
                { state.isLoading ? <WhiteboxLoader /> : ""}
                <TableActionBar
                    title={t("employees")}
                    search={search}
                    showFilter={false}
                    showDelete={selectedIds.length > 0}
                    delete={() => {
                        Confirm({
                            message: t("delete_confirmation"),
                            onConfirm: () => remove()
                        })
                    }}
                    addText={t("add_to_employees")}
                    add={ havePermission("Add Employee") ? () => dispatch( addEmployeeSlice.actions.setIsOpen(true) ) : undefined }
                    second_button={false?t("issue_monthly_salaries"):undefined}
                    second_button_action={false ?() => dispatch( salariesSlice.actions.setIsOpen(true) ):undefined}
                    />
                
                {/* <DashboardTable
                
                    header={[ t("name"), t("serial_no"), t("mobile"), t("job"), t("salary"), t("working_status"), "" ]}
                    body={generateData()}
                    onSelect={toggleSelectedId}
                    hasMore={state.hasMore}
                    loadMore={()=>{}}
                    pagesInfo={pagesInfo}
                    setPagesInfo={setPagesInfo}
                    sort_fields={getListSort(['name'
                    ,'serial_no','mobile','job','salary','working_status',''],'Employee')}
                    fetchSortedData={fetchSortedData}
                    /> */}
                    <SortTable
                      header={[ t("name"), t("serial_no"), t("mobile"), t("job"), t("salary"), t("working_status"), "" ]}
                     state={state.employees[state.page]??[]}
                      onSelect={toggleSelectedId}
                      hasMore={state.hasMore}
                      loadMore={()=>{}}
                      pagesInfo={pagesInfo}
                      setPagesInfo={setPagesInfo}
                      sort_fields={getListSort(['name'
                      ,'serial_no','mobile','job','salary','working_status',''],'Employee')}
                      fetchSortedData={fetchSortedData}
                    >
                        <>
                        {
                            rows()
                        }
                        </>
                    </SortTable>
                <AddModal />

                <SlariesModal />
                
                { activeEmployee >= 0 ?
                <SalariesHistoryModal isOpen={true} 
                toggle={() => setActiveEmployee(-1)} 
                employee_name={state.employees[state.page][activeEmployee].name} 
                salaries={state.employees[state.page][activeEmployee].salaries} /> : "" }
                
            </> : <div className="center"><EllipsisLoader /></div> }
        </>
    )

}